import {Button, Link} from '@components/common/button/button'
import {SettingsIcon} from '@components/common/icons/icons'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Workflow} from 'yougile-model'
import {popupStore} from './workflow-popup-store'

export const WorkflowList = observer(() => {
  const add = () => popupStore.editNew()
  const list = popupStore.workflows
  return list.length === 0 ? (
    <EmptyWorkflows />
  ) : (
    <>
      <Link onClick={add} className="mb-24">
        {Lang.msg.add}
      </Link>
      {list.map(workflow => (
        <WorkflowRow key={workflow.id} {...{workflow}} />
      ))}
    </>
  )
})

const WorkflowRow = observer(({workflow}: {workflow: Workflow}) => {
  const edit = () => popupStore.edit(workflow)
  const remove = () => popupStore.remove(workflow)
  return (
    <div className="flex my-8 items-center">
      <SettingsIcon className="text-third-old" />
      <div className="flex-grow ml-4 font-semibold">{workflow.name}</div>
      <Link onClick={edit}>{Lang.msg.edit}</Link>
      <Link onClick={remove} className="text-obscure-old ml-8">
        {Lang.msg.delete}
      </Link>
    </div>
  )
})

const EmptyWorkflows = observer(() => {
  const add = () => popupStore.editNew()
  return (
    <div className="flex items-center flex-col my-24">
      <div className="text-third-old text-18 my-24 text-center">
        {Lang.msg.workflow.empty}
      </div>
      <Button onClick={add}>{Lang.msg.add}</Button>
    </div>
  )
})
